import { Link } from "react-router";
import { IoClose } from "react-icons/io5";
import GemLogo from "../gemLogo";
import Logout from "../logout";
// import ProtectedRoute from "./ProtectedRoute";
import Functions from "./index.functino";
const Navbar = () => {
  const {
    isLoggedIn,
    setIslogout,
    setIsNavOpen,
    isActive,
    isNavOpen,
    navigate,
    islogout,
    dispatch,
    logout,
  } = Functions();
  return (
    <div className="relative z-40 overflow-visible">
      <div className="flex justify-between items-center px-3 sm:px-5 sm:pt-3 lg:pt-5 lg:px-5 xl:px-10 pt-2">
        <GemLogo />
        <div className="flex justify-center items-center gap-1 sm:gap-2 lg:gap-4">
          <div className="hidden sm:flex text-secondary justify-between gap-[2px] sm:gap-1 lg:gap-1 rounded-full items-center p-[2px] sm:p-1 lg:p-2 bg-[#21212170]">
            {isLoggedIn ? (
              <>
                <div
                  className="bg-primary rounded-full px-3 text-xs :py-[1px] sm:px-5 sm:text-xs lg:text-sm sm:py-1 lg:px-5 lg:py-1 hover:text-goldMetallic cursor-pointer font-onestRegular transition-transform duration-300 hover:scale-105"
                  onClick={() => {
                    setIslogout(true);
                  }}
                >
                  Logout
                </div>
                <Link
                  to={"/dashboard"}
                  className="hover:bg-primary rounded-full px-3 text-xs py-[1px] sm:px-5 sm:text-xs lg:text-sm sm:py-1 lg:px-5 lg:py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                >
                  Dashboard
                </Link>
              </>
            ) : (
              <>
                <Link
                  to={"/login"}
                  className="bg-primary rounded-full px-3 text-xs py-[1px] sm:px-5 sm:text-xs lg:text-sm sm:py-1 lg:px-5 lg:py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="hover:bg-primary rounded-full px-3 text-xs py-[1px] sm:px-5 sm:text-xs lg:text-sm sm:py-1 lg:px-5 lg:py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                >
                  Register
                </Link>
              </>
            )}
          </div>
          <div className="flex items-center gap-1 sm:gap-1 lg:gap-2">
            <h1 className="text-secondary font-onestMedium xs:text-sm">Menu</h1>
            <div
              className="bg-raisinBlack cursor-pointer rounded-full w-10 h-10 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex justify-center items-center group"
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <div>
                <div className="flex mb-[2px]">
                  <div className="border-[2px] border-secondary w-3 h-3 rounded-[4px] mr-[2px]"></div>
                  <div className="border-[2px] border-orangeCrayola w-3 h-3 rounded-[4px] group-hover:rotate-60 transition-transform duration-300"></div>
                </div>
                <div className="flex">
                  <div className="border-[2px] border-secondary w-3 h-3 rounded-[4px] mr-[2px]"></div>
                  <div className="border-[2px] border-secondary w-3 h-3 rounded-[4px]"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`fixed inset-0 bg-primary bg-opacity-50 backdrop-blur-md transition-opacity duration-300 ${
          isNavOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsNavOpen(false)}
      ></div>
      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[500px] lg:w-[580px] text-white p-3 sm:p-5 transform ${
          isNavOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300`}
      >
        <div className="rounded-[30px] sm:rounded-[50px] bg-[#121212] w-full h-full flex flex-col pl-5 py-2 pr-5 sm:pl-6 sm:pr-4 lg:pl-10 lg:pr-5">
          {/* Header Section */}
          <div className="xs:flex xs:justify-between xs:items-center mt-2.5 sm:mt-6">
            <div className=" text-secondary sm:hidden xs:flex justify-between gap-2 sm:gap-1 lg:gap-1 rounded-full items-center p-1 lg:p-2 bg-[#21212170]">
              {isLoggedIn ? (
                <>
                  <div
                    className="bg-primary rounded-full px-3 text-xs sm:px-5 sm:text-xs lg:text-sm lg:px-5 py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                    onClick={() => {
                      setIslogout(true);
                      setIsNavOpen(false);
                    }}
                  >
                    Logout
                  </div>
                  <Link
                    to={"/dashboard"}
                    className="hover:bg-primary rounded-full px-3 text-xs sm:px-5 sm:text-xs lg:text-sm lg:px-5 py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                  >
                    Dashboard
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="bg-primary rounded-full px-3 text-xs sm:px-5 sm:text-xs lg:text-sm lg:px-5 py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="hover:bg-primary rounded-full px-3 text-xs sm:px-5 sm:text-xs lg:text-sm sm:py-1 lg:px-5 py-1 hover:text-goldMetallic font-onestRegular transition-transform duration-300 hover:scale-105"
                  >
                    Register
                  </Link>
                </>
              )}
            </div>
            <div className="flex justify-end items-center">
              <button
                className="group mb-4 sm:mb-5 lg:mb-5 bg-goldMetallic text-sm w-5 h-5 sm:w-5 sm:h-5 sm:text-xl lg:text-2xl lg:w-7 lg:h-7 rounded-full text-primary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
                onClick={() => setIsNavOpen(false)}
              >
                <IoClose className=" transform transition-transform duration-300 group-hover:rotate-180" />
              </button>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto dashboard-scrollbar w-full h-full">
            <ul className="flex flex-col w-full h-full">
              <li
                className={`text-xl mb-8 mt-6 sm:mb-16 sm:mt-8 sm:text-3xl lg:text-4xl relative z-10 group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/" className="relative block">
                  Home
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/")
                        ? " text-[#b61ed427] translate-x-14 sm:translate-x-24"
                        : "group-hover:text-[#b61ed427] group-hover:sm:translate-x-24"
                    }`}
                  >
                    01
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/job-listing")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <div
                  className="relative block cursor-pointer"
                  onClick={() => {
                    // <ProtectedRoute >
                    //     {navigate('/job-listing')}
                    // </ProtectedRoute>
                    navigate("/job-listing");
                  }}
                >
                  Jobs
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform  translate-x-0 transition-transform duration-300 ${
                      isActive("/job-listing")
                        ? " text-[#b61ed427] translate-x-12 sm:translate-x-20"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-20"
                    }`}
                  >
                    02
                  </span>
                </div>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative z-10  group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/talent")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/talent" className="relative block">
                  Talent
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/talent")
                        ? " text-[#b61ed427] translate-x-16 sm:translate-x-28"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-28"
                    }`}
                  >
                    03
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative z-10  group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/news")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/news" className="relative block">
                  News
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/news")
                        ? " text-[#b61ed427] translate-x-14 sm:translate-x-24"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-24"
                    }`}
                  >
                    04
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative z-10  group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold  ${
                  isActive("/event")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/event" className="relative block">
                  Events
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/event")
                        ? " text-[#b61ed427] translate-x-[70px] sm:translate-x-[120px]"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-[120px]"
                    }`}
                  >
                    05
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/missionShe")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/missionShe" className="relative block">
                  Mission SHE
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform  translate-x-0 transition-transform duration-300 ${
                      isActive("/missionShe")
                        ? " text-[#b61ed427] translate-x-32 sm:translate-x-56"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-56"
                    }`}
                  >
                    06
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative z-10  group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/packages")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/packages" className="relative block">
                  Packages
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/packages")
                        ? " text-[#b61ed427] translate-x-24 sm:translate-x-40"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-40"
                    }`}
                  >
                    07
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl mb-8 sm:mb-16 sm:text-3xl lg:text-4xl relative z-10  group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/team")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/team" className="relative block">
                  Teams
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform   translate-x-0 transition-transform duration-300 ${
                      isActive("/team")
                        ? " text-[#b61ed427] translate-x-16 sm:translate-x-28"
                        : "group-hover:text-[#b61ed427]  group-hover:translate-x-28"
                    }`}
                  >
                    08
                  </span>
                </Link>
              </li>
              <li
                className={` text-xl sm:text-3xl lg:text-4xl relative group hover:text-[#B71ED4] transform duration-300 hover:font-onestBold ${
                  isActive("/contact-us")
                    ? "text-[#B71ED4] font-onestBold"
                    : "font-onestRegular"
                }`}
              >
                <Link to="/contact-us" className="relative block">
                  Contact Us
                  <span
                    className={`font-onestBold text-3xl sm:text-6xl lg:text-7xl text-[#FFFFFF18] absolute left-0 bottom-2 -z-10 transform  translate-x-0 transition-transform duration-300 ${
                      isActive("/contact-us")
                        ? " text-[#b61ed427] translate-x-28 sm:translate-x-48"
                        : "group-hover:text-[#b61ed427] group-hover:translate-x-48"
                    }`}
                  >
                    09
                  </span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="py-4">
            <p className="text-secondary font-onestSemiBold xs:text-xs sm:text-xs lg:text-sm">
              <span
                className="hover:underline cursor-pointer transition-all duration-300 hover:text-goldMetallic"
                onClick={() => navigate("/privacy-policy")}
              >
                Privacy Policy
              </span>{" "}
              |{" "}
              <span
                className="hover:underline cursor-pointer transition-all duration-300 hover:text-goldMetallic"
                onClick={() => navigate("/terms-and-conditions")}
              >
                Terms & Conditions
              </span>
            </p>
          </div>
        </div>
      </div>
      <Logout
        islogout={islogout}
        setIslogout={setIslogout}
        logout={logout}
        dispatch={dispatch}
      />
    </div>
  );
};

export default Navbar;
